// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__dfLeS","inner":"footer_inner__vkSMw","logo":"footer_logo__RPxe3"};